import script from "./version.vue?vue&type=script&setup=true&lang=js"
export * from "./version.vue?vue&type=script&setup=true&lang=js"

import "./version.vue?vue&type=style&index=0&id=1d872838&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d872838"]])

export default __exports__